var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.3 31.3",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.3 29.6c0 .8-.6 1.6-1.4 1.6H1.4c-.8 0-1.4-.9-1.4-1.6L1.4 9.5c0-.8.6-1.3 1.4-1.3h2.8c-.1 0-.2 1.6-.2 2.6v.4c.1.7.7 1.2 1.4 1.2h.1c.8-.1 1.3-.7 1.2-1.5v-.1c0-.1 0 .1 0 0 0-1 .1-2.7.3-2.7h7.5c.2 0 .3 1.7.3 2.7v.2c0 .7.5 1.2 1.2 1.3.8.1 1.4-.5 1.5-1.3v-.4c0-.9-.1-2.5-.2-2.5h2.8c.8 0 1.4.5 1.4 1.3l1.4 20.2zm-6.2-18.9C18.1 4.7 15.4 0 12 0 8.6 0 6 4.7 6 10.7c0 .4.3.7.7.7s.7-.3.7-.7c0-5.1 2.1-9.3 4.7-9.3 2.5 0 4.7 4.3 4.7 9.3 0 .4.3.7.7.7s.6-.3.6-.7z"
  })));
}

export default SvgCheckout;